import React from 'react';
import { get } from 'lodash';
import { getTextColor } from '@src/components/overview-dashboard/metrics-container/spi-widget/SPIMetricsText';
import { SPI_METRIC } from '@components/top-widget-panel/spi-panel/widgets/constants';
import humanizeValue from '@utils/overview/humanizeValue';
import { LOCAL_METRIC_SWITCH_MAP, getMetricUnit } from '@utils/metrics';
import { calculatePctShare } from '@utils/table/pctShare';
import { StyledCell, StyledTrendWrapper } from './styled';
import { getDodDiff } from '@src/components/metrics-panel-hz/utils/calculateDodTotal';
import { getMetricFilterMetric } from './utils';
import { Trend } from '@components/common';
import { Tooltip } from 'antd';
// TODO: humanize in utils

function ValueCell({ cellData, column, container, rowData }) {
  if (['NA', 'low'].includes(cellData)) {
    return (
      <StyledCell>
        <span>{cellData}</span>
      </StyledCell>
    );
  }
  const textStyle: any = { flex: 1 };
  let classStr = '';

  const { metric, metricInfo } = column;
  const isReverseMetric = get(column, ['errorMetricInfo', 'reverse'], metricInfo.reverse);

  if (!column.colorless && metric === SPI_METRIC) {
    textStyle.color = getTextColor(cellData);
    textStyle.fontWeight = 600;
    classStr = 'color-critical';
  }

  // LOCAL_METRIC_SWITCH_MAP contains all the local calculated metrics and its unit is %
  const unit =
    column.mfPctChecked || !!LOCAL_METRIC_SWITCH_MAP[metric]
      ? '%'
      : getMetricUnit({ metricKey: metric });
  const { humanizedNumber, humanizedUnit } = humanizeValue(cellData, metric, unit as string);

  const dodValue = rowData[getMetricFilterMetric(metric)];
  const trend = getDodDiff(cellData, dodValue);
  const { humanizedNumber: humanizedDoDNumber, humanizedUnit: humanizedDoDUnit } = humanizeValue(
    dodValue,
    metric,
    unit as string,
  );
  const dodHumanized = `${humanizedDoDNumber} ${humanizedDoDUnit}`;

  // relative cell share to max value
  const pctShare = rowData.hidePctShare
    ? 0
    : calculatePctShare({
        value: cellData,
        pctShareMaxValue: get(
          container,
          ['props', 'headerProps', 'pctShareMaxValues', column.dataKey],
          0,
        ),
      });

  const showTrend = get(container, ['props', 'headerProps', 'showTrend'], false);

  return (
    <StyledCell pctShare={pctShare} showTrend={showTrend}>
      <div style={textStyle} className={classStr}>
        {`${humanizedNumber} ${humanizedUnit}`}
      </div>
      {showTrend && (
        <Tooltip title={dodHumanized}>
          <StyledTrendWrapper>
            <Trend
              value={trend}
              style={{
                display: 'flex',
                paddingLeft: 4,
                fontSize: '11px',
                alignItems: 'center',
                justifyContent: 'end',
                fontWeight: 400,
              }}
              reverse={isReverseMetric}
            />
          </StyledTrendWrapper>
        </Tooltip>
      )}
    </StyledCell>
  );
}

export default React.memo(ValueCell);
